import axios from 'axios';
import { useQuery } from 'react-query';
import { KA_API_URL } from '../../config/baseUrl';

/**
 * URIs
 */

export const GET_HOURS_OF_OPERATION = `${KA_API_URL}/config/hours_of_operation`;

/**
 * Requests
 */

const fetchHoursOfOperation = async () => axios.get(GET_HOURS_OF_OPERATION);

/**
 * Hooks
 */

export const HOURS_OF_OPERATION_QUERY_KEY_BASE = 'hoursOfOperation';

export const useHoursOfOperation = queryConfig =>
  useQuery(
    [HOURS_OF_OPERATION_QUERY_KEY_BASE],
    async () => {
      const response = await fetchHoursOfOperation();

      return response?.data ?? [];
    },
    queryConfig,
  );
